import { Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import SettingsPage from '../pages/settings';
import ProfilePage from '../pages/profile';

/**
 * Main Routes
 * Handles main application routes like /profile, /settings, etc.
 *
 * Pages:
 * - /profile - User profile page
 * - /settings - User settings (Coming Soon)
 */
export default function MainRoutes() {
  return (
    <Routes>
      <Route index element={
        <MainLayout showSidebar={false}>
          <ProfilePage />
        </MainLayout>
      } />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
